module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB1026-4a68e71fd8449c1fb7c51ae5ede68401.png";